import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import PopoverMenu from "@/components/ui/PopoverMenu.vue";
import { Icon } from "@iconify/vue";
import type { TableAction } from "./types";

interface Props<T = any> {
  row: T;
  actions: TableAction<T>[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionDropdown',
  props: {
    row: {},
    actions: {}
  },
  setup(__props: any) {

const props = __props;

const loadingAction = ref<string | null>(null);

const actionItems = computed(() => {
  return props.actions.map((action) => {
    const isLoading = loadingAction.value === action.label;
    return {
      label: action.label,
      icon: isLoading ? "mdi:loading" : typeof action.icon === "string" ? action.icon : undefined,
      onClick: async () => {
        loadingAction.value = action.label;
        try {
          await action.onClick(props.row);
        } finally {
          loadingAction.value = null;
        }
      },
      disabled: loadingAction.value !== null && !isLoading,
      danger: action.variant === "destructive",
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopoverMenu, {
    items: actionItems.value,
    "trigger-icon": "mdi:dots-horizontal",
    placement: "bottom-right",
    "stay-open": false,
    class: "data-table-action-dropdown"
  }, null, 8, ["items"]))
}
}

})